import { ActionList, Button, Popover } from '@shopify/polaris';
import { useState } from 'react';
import { ExportModal } from './ExportModal';

const MODES = [
  { kind: 'analisis', label: 'PDF Análisis' },
  { kind: 'series', label: 'PDF por Series' },
  { kind: 'excel', label: 'Excel' },
];

/**
 * Dropdown "Exportar" del header del informe de Reposición. Gemelo
 * del de Eficacia — abre el `ExportModal` en el modo elegido.
 */
export const ExportMenu = ({ disabled, range, currency, exportParamsArgs }) => {
  const [open, setOpen] = useState(false);
  const [modalMode, setModalMode] = useState(null);

  const handleSelect = (kind) => {
    setOpen(false);
    setModalMode(kind);
  };

  return (
    <>
      <Popover
        active={open}
        activator={
          <Button onClick={() => setOpen((s) => !s)} disclosure disabled={disabled}>
            Exportar
          </Button>
        }
        onClose={() => setOpen(false)}
        preferredAlignment="right"
      >
        <ActionList items={MODES.map((m) => ({ content: m.label, onAction: () => handleSelect(m.kind) }))} />
      </Popover>
      <ExportModal
        open={modalMode !== null}
        mode={modalMode}
        onClose={() => setModalMode(null)}
        range={range}
        currency={currency}
        exportParamsArgs={exportParamsArgs}
      />
    </>
  );
};
